module.exports = __webpack_public_path__ + "img/Mestari-Heittäjä-I.affbfb08.png";